export interface UpdateSystemCodeAddressRequest {
  codes: {
    code: string
    areaCode: string
    zipCode: string
    name: string
    revision: number
  }[]
}

export function UpdateSystemCodeAddressRequestToJSON(
  value: UpdateSystemCodeAddressRequest
): any {
  return {
    codes:
      value.codes.length > 0
        ? value.codes.map(code => {
            return {
              code: code.code !== '' ? code.code : undefined,
              area_code: code.areaCode !== '' ? code.areaCode : undefined,
              zip_code: code.zipCode !== '' ? code.zipCode : undefined,
              name: code.name !== '' ? code.name : undefined,
              revision: code.revision !== 0 ? code.revision : undefined
            }
          })
        : undefined
  }
}
